export default __webpack_public_path__ + "static/media/fudgecookie.13bf8087.png";